import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { deleteOffice } from 'modules/settings/api';

export const useMutationCompanyOfficeDelete = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { successToast, errorToast } = useCustomToast();

  const { mutateAsync: deleteCompanyOfficeMutate, isLoading: companyOfficeDeleteLoading } =
    useMutation(deleteOffice, {
      onSuccess: () => {
        successToast(t('Office deleted'));
        queryClient.refetchQueries(QUERY_KEYS.SETTINGS_PROFILE_COMPANY_DELETE_OFFICE);
        queryClient.refetchQueries(QUERY_KEYS.RENTALS_OFFICES);
      },
      onError: () => errorToast(),
    });

  return { deleteCompanyOfficeMutate, companyOfficeDeleteLoading };
};
